import initializeComponent from '../Shared/react-initialize';
import { ReviewStars } from '@ifixit/product-page-components';

initializeComponent('ReviewStars', ReviewStars);
